var _circle, _circle2, _path, _path2, _g, _path3, _path4, _ellipse, _mask, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse2, _ellipse3, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1392,
    height: 1392,
    viewBox: "0 0 1392 1392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 696,
    cy: 696,
    r: 696,
    fill: "#F4D150"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1392,
    height: 1392
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 696,
    cy: 696,
    r: 696,
    fill: "#FFEDEF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_996)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M893.695 1364.4C840.945 1291.14 799.674 1112.87 794.789 1042.05L543.863 933.981L439.463 1364.4H893.695Z",
    fill: "#FC909F",
    stroke: "black",
    strokeWidth: 14.6526
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_65_996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 439,
    y: 933,
    width: 455,
    height: 432
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M893.695 1364.4C840.945 1291.14 799.674 1112.87 794.789 1042.05L543.863 933.981L439.463 1364.4H893.695Z",
    fill: "#FFEDEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_65_996)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 783.916,
    cy: 926.781,
    rx: 216.126,
    ry: 197.811,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_996)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M893.811 1327.9C841.061 1254.63 799.79 1112.99 794.906 1042.17L543.979 934.107L439.579 1327.9H893.811Z",
    fill: "#F9C9B6",
    stroke: "black",
    strokeWidth: 14.6526
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_65_996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 439,
    y: 934,
    width: 455,
    height: 431
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M893.811 1364.53C841.061 1291.27 799.79 1112.99 794.906 1042.17L543.979 934.107L439.579 1364.53H893.811Z",
    fill: "#F9C9B6"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_65_996)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 783.916,
    cy: 926.78,
    rx: 216.126,
    ry: 197.811,
    fill: "black"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_65_996",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.29 710.354C1003.19 709.929 1003.09 709.504 1002.99 709.079C1002.89 708.654 1002.78 708.23 1002.68 707.806L942.616 457.109C942.558 456.862 942.499 456.615 942.44 456.368C942.38 456.121 942.321 455.874 942.261 455.627L941.994 454.511L941.989 454.512C904.558 302.694 751.524 209.343 599.231 245.831C446.938 282.32 352.823 434.885 388.256 587.182L388.249 587.184L450.49 846.967L450.541 846.955C489.381 996.795 641.282 1088.51 792.453 1052.29C943.623 1016.07 1037.47 865.478 1004.19 714.305L1004.24 714.295L1003.29 710.354Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.29 710.354C1003.19 709.929 1003.09 709.504 1002.99 709.079C1002.89 708.654 1002.78 708.23 1002.68 707.806L942.616 457.109C942.558 456.862 942.499 456.615 942.44 456.368C942.38 456.121 942.321 455.874 942.261 455.627L941.994 454.511L941.989 454.512C904.558 302.694 751.524 209.343 599.231 245.831C446.938 282.32 352.823 434.885 388.256 587.182L388.249 587.184L450.49 846.967L450.541 846.955C489.381 996.795 641.282 1088.51 792.453 1052.29C943.623 1016.07 1037.47 865.478 1004.19 714.305L1004.24 714.295L1003.29 710.354Z",
    fill: "#F9C9B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.29 710.354L989.027 713.704L989.034 713.736L989.042 713.768L1003.29 710.354ZM1002.99 709.079L1017.24 705.665L1017.24 705.665L1002.99 709.079ZM1002.68 707.806L988.432 711.22L988.439 711.252L988.447 711.283L1002.68 707.806ZM942.616 457.109L928.358 460.487L928.362 460.505L928.367 460.523L942.616 457.109ZM942.261 455.627L928.012 459.041L928.016 459.06L928.021 459.078L942.261 455.627ZM941.994 454.511L956.243 451.097L952.834 436.868L938.6 440.257L941.994 454.511ZM941.989 454.512L927.762 458.02L931.242 472.133L945.382 468.767L941.989 454.512ZM599.231 245.831L602.645 260.081L602.645 260.081L599.231 245.831ZM388.256 587.182L391.687 601.427L405.822 598.022L402.527 583.862L388.256 587.182ZM388.249 587.184L384.817 572.938L370.589 576.366L373.999 590.598L388.249 587.184ZM450.49 846.967L436.241 850.381L439.654 864.627L453.901 861.217L450.49 846.967ZM450.541 846.955L464.725 843.278L461.117 829.357L447.131 832.705L450.541 846.955ZM792.453 1052.29L789.039 1038.04L789.039 1038.04L792.453 1052.29ZM1004.19 714.305L1000.78 700.056L986.788 703.407L989.88 717.456L1004.19 714.305ZM1004.24 714.295L1007.65 728.544L1021.9 725.13L1018.48 710.88L1004.24 714.295ZM1017.56 707.004C1017.45 706.559 1017.35 706.112 1017.24 705.665L988.74 712.493C988.836 712.896 988.932 713.3 989.027 713.704L1017.56 707.004ZM1017.24 705.665C1017.13 705.218 1017.02 704.773 1016.91 704.329L988.447 711.283C988.545 711.687 988.643 712.09 988.74 712.494L1017.24 705.665ZM928.367 460.523L988.432 711.22L1016.93 704.392L956.865 453.695L928.367 460.523ZM956.874 453.731C956.813 453.473 956.751 453.214 956.689 452.953L928.19 459.782C928.246 460.016 928.302 460.251 928.358 460.487L956.874 453.731ZM956.689 452.953C956.627 452.694 956.564 452.435 956.501 452.175L928.021 459.078C928.077 459.313 928.134 459.547 928.19 459.782L956.689 452.953ZM927.744 457.925L928.012 459.041L956.51 452.213L956.243 451.097L927.744 457.925ZM945.382 468.767L945.388 468.765L938.6 440.257L938.595 440.258L945.382 468.767ZM956.215 451.005C916.858 291.371 755.948 193.216 595.817 231.582L602.645 260.081C747.099 225.471 892.258 314.017 927.762 458.02L956.215 451.005ZM595.817 231.582C435.685 269.948 336.727 430.365 373.984 590.502L402.527 583.862C368.918 439.405 458.19 294.691 602.645 260.081L595.817 231.582ZM391.68 601.429L391.687 601.427L384.824 572.937L384.817 572.938L391.68 601.429ZM464.74 843.553L402.498 583.77L373.999 590.598L436.241 850.381L464.74 843.553ZM447.131 832.705L447.08 832.717L453.901 861.217L453.952 861.205L447.131 832.705ZM436.358 850.631C477.198 1008.19 636.915 1104.62 795.867 1066.54L789.039 1038.04C645.65 1072.39 501.565 985.401 464.725 843.278L436.358 850.631ZM795.867 1066.54C954.819 1028.45 1053.49 870.113 1018.5 711.155L989.88 717.456C1021.45 860.842 932.428 1003.68 789.039 1038.04L795.867 1066.54ZM1000.82 700.045L1000.78 700.056L1007.6 728.555L1007.65 728.544L1000.82 700.045ZM989.042 713.768L989.986 717.709L1018.48 710.88L1017.54 706.94L989.042 713.768Z",
    fill: "black",
    mask: "url(#path-9-inside-1_65_996)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M657.537 807.727C666.695 870 771.095 899.306 866.337 827.874",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M802.232 484.323C822.99 474.554 871.832 465.641 901.137 508.133",
    stroke: "black",
    strokeWidth: 14.6526,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M525.953 577.025C533.538 555.374 561.42 514.294 612.267 523.182",
    stroke: "black",
    strokeWidth: 14.6526,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M669.582 177.621L669.862 177.651L670.143 177.659C767.836 180.533 843.781 219.411 897.525 266.858C949.014 312.314 979.76 365.301 989.787 401.415C974.915 409.903 949.439 417.208 916.945 423.198C881.502 429.733 838.946 434.505 795.524 437.907C708.683 444.709 618.997 445.985 577.107 445.075L554.861 444.591L572.468 458.197C581.617 465.266 593.795 470.187 606.676 473.647C619.649 477.132 633.853 479.27 647.452 480.485C661.46 481.737 675.117 482.031 686.431 481.742C647.649 511.641 598.288 534.63 549.617 551.67C493.401 571.352 438.733 582.882 403.716 588.014L395.844 589.167L397.642 596.918C409.904 649.772 432.445 742.165 447.563 804.134C454.271 831.627 459.517 853.132 461.757 862.538C465.729 879.22 478.234 902.998 492.508 924.916C505.669 945.124 521.024 964.803 533.982 976.915L505.27 1093.45H396.984C427.526 1046.88 433.973 993.072 427.745 936C421.004 874.224 399.314 807.772 376.45 741.239C374.199 734.69 371.937 728.139 369.676 721.59C348.855 661.298 328.091 601.173 316.842 543.548C304.383 479.72 303.827 419.985 327.219 367.464C365.092 282.429 432.229 233.049 499.384 205.836C566.697 178.56 633.528 173.779 669.582 177.621Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.6526
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 616.007,
    cy: 615.23,
    rx: 32.9684,
    ry: 36.6316,
    transform: "rotate(-6.77646 616.007 615.23)",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 850.561,
    cy: 578.585,
    rx: 32.9684,
    ry: 36.6316,
    transform: "rotate(-6.27568 850.561 578.585)",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M744.446 619.106C751.583 669.891 782.584 706.225 782.584 706.225C782.584 706.225 772.947 729.774 735.652 727.617",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.874 667.609V663.509L476.38 661.365C462.702 652.972 446.069 648.38 428.883 648.38C408.222 648.38 388.878 654.781 375.1 667.776C361.167 680.917 353.649 700.131 355.645 724.083C357.59 747.423 365.426 764.602 378.422 776.016C377.355 779.676 377.04 783.622 377.534 787.775C378.96 799.747 385.013 808.374 394.366 813.69C403.282 818.757 414.692 820.547 426.847 820.547C446.918 820.547 464.517 809.752 477.918 795.313L479.874 793.205V790.329V667.609Z",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.751 725.247C502.012 722.859 502.146 720.435 502.146 717.98C502.146 680.552 467.322 655.706 428.883 655.706C390.444 655.706 359.283 679.516 362.946 723.474C364.984 747.935 373.737 764.033 387.309 773.722C385.153 777.473 384.21 781.878 384.809 786.908C387.114 806.256 403.63 813.221 426.847 813.221C467.527 813.221 499.714 761.766 501.751 725.247Z",
    fill: "#F9C9B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M445.074 686.844C430.422 680.129 398.186 676.588 386.464 716.15",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M406.611 688.674C414.548 695.39 429.689 716.148 426.758 745.453",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.74 1402.99H184.529C244.237 1295.51 329.163 1227.09 466.849 1195.7C525.508 1182.33 593.844 1175.66 674.02 1175.66C708.658 1175.66 735.611 1180.94 761.19 1187.91C770.665 1190.5 780.189 1193.39 789.932 1196.35C806.058 1201.25 822.786 1206.33 840.886 1210.49L841.399 1210.61L841.923 1210.65C1010.89 1224.59 1112.21 1299.64 1185.74 1402.99Z",
    fill: "#77311D",
    stroke: "black",
    strokeWidth: 14.6526
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M424.668 1203.65L458.197 1131.86C458.998 1130.15 460.988 1129.33 462.772 1129.96C601.703 1179.14 728.091 1175.68 845.219 1143.07C846.693 1142.66 848.268 1143.21 849.171 1144.44L900.208 1214.23C901.61 1216.15 900.896 1218.86 898.683 1219.72C775.575 1268.07 544.572 1259.85 426.443 1208.49C424.569 1207.68 423.803 1205.5 424.668 1203.65Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.6526
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 732.632,
    height: 1172.21,
    fill: "white",
    transform: "translate(329.685 157.517)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.ddfc9e5e5a6f3bcbf67a794cb46ff188.svg";
export { ForwardRef as ReactComponent };